import apiService from './apiService.js';

const resource = '/people';

export default {
    generateInviteLink(personId) {
        return apiService.post(`${resource}/generateLink`,
            {
                person_id: personId,
            });
    },
    csvExport(csvType, involveType) {
        return apiService.get(`/people/csv/?csv_type=${csvType}&involve_type=${involveType}`);
    },
    getTimelyReports() {
        return apiService.get('/people/get-timely-reports/');
    },
    getUserLocations() {
        return apiService.get(`${resource}/locations`);
    }
};
